import { Tabs } from 'antd';
import React from 'react';
import { useNavigate, useParams } from 'react-router';
import MediaLibrary from './mediaLibrary';
import MediaQualification from './mediaQualification';

const MediasComponent = () => {
  const navigate = useNavigate();
  const { tab } = useParams();

  const items = [
    {
      key: 'media-library',
      label: 'Bibliothèque médias',
      children: <MediaLibrary />,
    },
    {
      key: 'media-qualification',
      label: 'Médias à qualifier',
      children: <MediaQualification />,
    },
  ];

  const handleTabChange = (key) => {
    navigate(`/dashboard/medias/${key}`);
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Tabs
        activeKey={tab || 'media-library'}
        items={items}
        onChange={handleTabChange}
        tabBarStyle={{ marginBottom: 0 }}
      />
    </div>
  );
};

export default MediasComponent;
